import { Component, OnInit } from '@angular/core';
declare var jQuery: any;

@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard-home.component.css']
})
export class DashboardHomeComponent implements OnInit {

modules = [
  { title: 'Elephant Movement Dashboard', type: 'internal', route: 'dashboard', icon: 'fa fa-paw', image: 'assets/images/Elephant_movement_banner.png' },
  { title: 'Problematic Elephant Dashboard', type: 'internal', route: 'dashboard', icon: 'fa fa-exclamation-triangle', image: 'assets/images/Problematic_Elephant_banner.png' },
  { title: 'Squad Monitoring Dashboard', type: 'internal', route: 'squad-monitoring-dashboard', icon: 'fa fa-users', image: 'assets/images/squad_monitoring_banner.png' },
  { title: 'APO Module & EWG Dashboard', type: 'internal', route: 'apo-report', icon: 'fa fa-clipboard-list', image: 'assets/images/APO_Module_Banner.png' },
  { title: 'PRAHAR', type: 'external', url: 'https://prahar.wildlifeodisha.in', icon: 'fa fa-external-link-alt', image: 'assets/images/Prahar_banner.png' },
  { title: 'HAWK', type: 'external', url: 'https://hawkodisha.in', icon: 'fa fa-eye'  ,image: 'assets/images/Hawk_banner.png'}
];
	currentYear: number = new Date().getFullYear();
  selectedModule: any = null;
  constructor() { 

  }

  ngOnInit(): void {
    	(function($){
        $(document).ready(function () {

		    $(window).scroll(function () {
		        if ($(this).scrollTop() > 100) {
		            $('.scrollup').fadeIn();
		        } else {
		            $('.scrollup').fadeOut();
		        }
		    });

		    $('.scrollup').click(function () {
		        $("html, body").animate({
		            scrollTop: 0
		        }, 600);
		        return false;
		    });

	    });
    })(jQuery);
  }
  onCardClick(module: any) {
  if (module.type === 'external') {
    window.open(module.url, '_blank');
  } else {
    this.selectedModule = module;
    (window as any).jQuery('#modalLogin').modal('show'); // triggers modal
  }
}

}
